// extracted by mini-css-extract-plugin
module.exports = {"listsection":"listsection-module--listsection--3r21Q"};